import {
    Filter,
    FunctionField,
    TextField,
    TextInput,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { DefaultPagination } from "shared/src/components/DefaultPagination";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { RaListView } from "shared/src/components/views/RaListView";

const DamageReportListFilter = (props) => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <TextInput
                title={translate("equip.title")}
                label="equip.title"
                source="title"
                alwaysOn
            />
        </Filter>
    );
};

export const DamageReportList = (props) => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const translate = useTranslate();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaListView
            {...props}
            actions={<ToolbarWithHistory create={true} export={true} />}
            filters={<DamageReportListFilter />}
            pagination={<DefaultPagination />}
            perPage={50}
            sort={{ field: "id", order: "DESC" }}
        >
            <DatagridWithHistory bulkActionButtons={false}>
                <TextField label="equip.title" source="title" />
                <RaDateField label="equip.date" source="date" />
                <TextField label="equip.sku" source="sku.labelNumber" />
                <TextField label="equip.responsibleUser" source="responsibleUser.email" />
                <FunctionField
                    label="equip.status"
                    render={(record) => translate(`equip.damageReportStatus_${record.status}`)}
                />
            </DatagridWithHistory>
        </RaListView>
    );
};
